<template>
    <wrapper
        ref="rewardDetail"
        project="detail"
        headerHeight="100px"
        :request="request"
        :params="params"
        showAmount
    >
        <template slot="toolbar" slot-scope="scope">
            <tg-search-tool
                :data="searchData"
                @on-submit="handleSearch(scope.onSearch)"
            >
                <el-input
                    :placeholder="
                        $t('component.form.input.placeholder.below_member')
                    "
                    v-model="searchData.targetName"
                    class="tg-input"
                    size="small"
                    style="width: 200px"
                    clearable
                ></el-input>
            </tg-search-tool>
        </template>

        <!-- 平台 -->
        <template slot="source_type" slot-scope="scope">
            <span :class="['text-' + scope.row.source_type]">
                {{ $t("component.label.source_type." + scope.row.source_type) }}
            </span>
        </template>

        <!-- 單號 -->
        <template slot="betId" slot-scope="scope">
            <tg-bet-id :row="scope.row"></tg-bet-id>
        </template>

        <!-- 賽事內容 -->
        <template slot="betContent" slot-scope="scope">
            <tg-bet-content
                v-if="scope.row.source_type == 'tg'"
                :row="scope.row"
                closeBetContent
                closeOddIcon
            >
            </tg-bet-content>
            <third-party-saba-bet-content
                v-else-if="
                    ((scope.row.source_type == 'saba' || scope.row.source_type == 'sabawhite_sport') &&
                        (scope.row.content_type == 2 ||
                            scope.row.content_type == 5)) ||
                    (scope.row.source_type.includes('sport') && scope.row.serial_type == 1) //serial_type == 1 非串關
                "
                :row="scope.row"
                closeOddIcon
            ></third-party-saba-bet-content>
            <third-party-saba-parlay-bet-content
                v-else-if="
                    (scope.row.source_type == 'saba' || scope.row.source_type == 'sabawhite_sport') &&
                    (scope.row.content_type == 3 || scope.row.content_type == 4)
                "
                :row="scope.row"
                @on-click="handlePublicParlayDialog(scope.row)"
            ></third-party-saba-parlay-bet-content>
            <third-party-saba-parlay-bet-content
                v-else-if="
                    (scope.row.source_type != 'saba' && scope.row.source_type.includes('sport')) 
                "
                :row="scope.row"
                @on-click="handlePublicParlayDialog(scope.row)"
            ></third-party-saba-parlay-bet-content>
            <third-party-public-bet-content
                v-else
                :row="scope.row"
            ></third-party-public-bet-content>
        </template>

        <!-- 會員結果 -->
        <template slot="result_after" slot-scope="scope">
            <span
                :class="{
                    'text-green': scope.value > 0,
                    'text-red': scope.value < 0,
                }"
                >{{ scope.formated }}</span
            >
        </template>

        <!-- 獎金 -->
        <template slot="reward" slot-scope="scope">
            <span
                :class="{
                    'text-green': scope.value > 0,
                    'text-red': scope.value < 0,
                }"
                >{{ scope.formated }}</span
            >
        </template>
    </wrapper>
</template>

<script>
import wrapper from "./wrapper";
import TgSearchTool from "@/components/tool/TgSearchTool";
import minins from "./mixins";
import str from "@/utils/str";
import formatter from "@/utils/formatter";
import TgBetId from "@/components/slot/TgBetId";
import TgBetContent from "@/components/slot/TgBetContent";
import ThirdPartySabaBetContent from "@/components/slot/ThirdPartySabaBetContent";
import ThirdPartySabaParlayBetContent from "@/components/slot/ThirdPartySabaParlayBetContent";
import ThirdPartyPublicBetContent from "@/components/slot/ThirdPartyPublicBetContent";

export default {
    components: {
        wrapper,
        TgSearchTool,
        TgBetId,
        TgBetContent,
        ThirdPartySabaBetContent,
        ThirdPartySabaParlayBetContent,
        ThirdPartyPublicBetContent,
    },
    data() {
        return {
            amounts: {},
            columns: [],
        };
    },
    mixins: [minins],
    computed: {
        game_time() {
            return this.params.game_time;
        },
        game_name() {
            return this.params.game_name;
        },
        game_key() {
            return this.params.game_key;
        },
        request() {
            return {
                ...this.searchData,
                event: this.params.event,
                game_key: this.game_key,
            };
        },
    },
    mounted() {
        this.$store.commit("breadcrumb/clear");
        this.$store.commit("breadcrumb/add", {
            name: this.$route.name,
            params: this.$route.params,
            query: this.$route.query,
            path: this.$route.path,
            meta: {
                title: str.format(
                    "[{0}] {1} {2}",
                    this.params.title,
                    this.game_time,
                    this.game_name
                ),
            },
        });
    },
    methods: {
        parseProfit(profit) {
            return formatter.format(profit, "percent");
        },
        handlePublicParlayDialog(row) {
            if (row.dialog_type == "detail") {
                let data = {
                    trans_id: row.trans_id,
                    source_type: row.source_type,
                    bet_type:row.bet_type
                };
                this.$refs.rewardDetail.$refs.sabaParlayMatchs.showDialogForPublic(
                    data
                );
            } else {
                let data = {
                    trans_id: row.trans_id,
                    betId: row.bet_id,
                    content_type: row.content_type,
                    createtime: row.createtime,
                    source_type: row.source_type,
                    bet_type:row.bet_type
                };
                this.$refs.rewardDetail.$refs.sabaParlayResult.showDialogForPublic(
                    data
                );
            }
        },
    },
};
</script>
